import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveyModal = _resolveComponent("SurveyModal")!
  const _component_app_user_onboard_info = _resolveComponent("app-user-onboard-info")!
  const _component_app_user_add_exp_modal = _resolveComponent("app-user-add-exp-modal")!
  const _component_app_user_startup_skills_modal = _resolveComponent("app-user-startup-skills-modal")!
  const _component_app_user_main_skills_modal = _resolveComponent("app-user-main-skills-modal")!
  const _component_app_user_add_edu_modal = _resolveComponent("app-user-add-edu-modal")!
  const _component_app_user_standardtests_modal = _resolveComponent("app-user-standardtests-modal")!
  const _component_app_user_bio_modal = _resolveComponent("app-user-bio-modal")!
  const _component_app_user_avatar_modal = _resolveComponent("app-user-avatar-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.user !== undefined)
      ? (_openBlock(), _createBlock(_component_SurveyModal, {
          key: 0,
          onChecked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toogleVariable('checkedSurvey', true))),
          onOpened: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toogleVariable('openedSurvey', true))),
          onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toogleVariable('openedSurvey', false))),
          user: _ctx.user
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    (_ctx.checkedSurvey && !_ctx.openedSurvey)
      ? (_openBlock(), _createBlock(_component_app_user_onboard_info, {
          key: 1,
          onChecked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toogleVariable('checkedOnboardInfo', true))),
          onOpened: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toogleVariable('openedOnboardInfo', true))),
          onClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toogleVariable('openedOnboardInfo', false)))
        }))
      : _createCommentVNode("", true),
    (_ctx.checkedOnboardInfo && !_ctx.openedSurvey && !_ctx.openedOnboardInfo)
      ? (_openBlock(), _createBlock(_component_app_user_add_exp_modal, {
          key: 2,
          onChecked: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toogleVariable('checkedExperience', true))),
          onOpened: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toogleVariable('openedExperience', true))),
          onClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toogleVariable('openedExperience', false)))
        }))
      : _createCommentVNode("", true),
    (
        _ctx.checkedExperience &&
        !_ctx.openedSurvey &&
        !_ctx.openedOnboardInfo &&
        !_ctx.openedExperience
      )
      ? (_openBlock(), _createBlock(_component_app_user_startup_skills_modal, {
          key: 3,
          onChecked: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toogleVariable('checkedStartupExperience', true))),
          onOpened: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toogleVariable('openedStartupExperience', true))),
          onClosed: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toogleVariable('openedStartupExperience', false)))
        }))
      : _createCommentVNode("", true),
    (
        _ctx.checkedStartupExperience &&
        !_ctx.openedSurvey &&
        !_ctx.openedOnboardInfo &&
        !_ctx.openedExperience &&
        !_ctx.openedStartupExperience
      )
      ? (_openBlock(), _createBlock(_component_app_user_main_skills_modal, {
          key: 4,
          onChecked: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toogleVariable('checkedMainSkills', true))),
          onOpened: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toogleVariable('openedMainSkills', true))),
          onClosed: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toogleVariable('openedMainSkills', false)))
        }))
      : _createCommentVNode("", true),
    (
        _ctx.checkedMainSkills &&
        !_ctx.openedSurvey &&
        !_ctx.openedOnboardInfo &&
        !_ctx.openedExperience &&
        !_ctx.openedStartupExperience &&
        !_ctx.openedMainSkills
      )
      ? (_openBlock(), _createBlock(_component_app_user_add_edu_modal, {
          key: 5,
          onChecked: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toogleVariable('checkedEducation', true))),
          onOpened: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toogleVariable('openedEducation', true))),
          onClosed: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toogleVariable('openedEducation', false)))
        }))
      : _createCommentVNode("", true),
    (
        _ctx.checkedEducation &&
        !_ctx.openedSurvey &&
        !_ctx.openedOnboardInfo &&
        !_ctx.openedExperience &&
        !_ctx.openedStartupExperience &&
        !_ctx.openedMainSkills &&
        !_ctx.openedEducation
      )
      ? (_openBlock(), _createBlock(_component_app_user_standardtests_modal, {
          key: 6,
          onChecked: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toogleVariable('checkedStandardTest', true))),
          onOpened: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toogleVariable('openedStandardTest', true))),
          onClosed: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toogleVariable('openedStandardTest', false)))
        }))
      : _createCommentVNode("", true),
    (
        _ctx.checkedStandardTest &&
        !_ctx.openedSurvey &&
        !_ctx.openedOnboardInfo &&
        !_ctx.openedExperience &&
        !_ctx.openedStartupExperience &&
        !_ctx.openedMainSkills &&
        !_ctx.openedEducation &&
        !_ctx.openedStandardTest
      )
      ? (_openBlock(), _createBlock(_component_app_user_bio_modal, {
          key: 7,
          onChecked: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toogleVariable('checkedBioInfo', true))),
          onOpened: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toogleVariable('openedBioInfo', true))),
          onClosed: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toogleVariable('openedBioInfo', false)))
        }))
      : _createCommentVNode("", true),
    (
        _ctx.checkedBioInfo &&
        !_ctx.openedSurvey &&
        !_ctx.openedOnboardInfo &&
        !_ctx.openedExperience &&
        !_ctx.openedStartupExperience &&
        !_ctx.openedMainSkills &&
        !_ctx.openedEducation &&
        !_ctx.openedStandardTest &&
        !_ctx.openedBioInfo
      )
      ? (_openBlock(), _createBlock(_component_app_user_avatar_modal, {
          key: 8,
          onChecked: _cache[24] || (_cache[24] = ($event: any) => (_ctx.toogleVariable('checkedAvatar', true))),
          onOpened: _cache[25] || (_cache[25] = ($event: any) => (_ctx.toogleVariable('openedAvatar', true))),
          onClosed: _cache[26] || (_cache[26] = ($event: any) => (_ctx.toogleVariable('openedAvatar', false)))
        }))
      : _createCommentVNode("", true)
  ]))
}